
* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  padding-top: calc(var(--spacer) * 2);
  font-size: var(--body-size-medium);
}

.wrapper {
  padding: 2px;
}

.row {
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 4);
  cursor: default;

  .item-info {
    gap: calc(var(--spacer) * 2);
    align-items: center;
    flex: 1;
    display: flex;
    justify-content: space-between;
    min-width: 0;
    color: var(--chart-300-icon-buttons);
  }

  .item-user {
    font-weight: 700;
  }
}

.items {
  display: flex;
  flex-direction: column;
}

.name-tooltip {
  text-align: left;
  div {
    display: contents;
  }
}

.date-tooltip {
  text-align: center;
  div {
    display: contents;
  }
}

.user-tooltip {
  text-align: end;
  div {
    display: contents;
  }
}

gz-tooltip {
  flex-basis: 33.33%;
}

.row:not(:last-child) {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
}

#more-assets-to-next-scan {
  // this is needed in order for it to be aligned with the table label
  margin-left: -2px;
  padding-top: calc(2 * var(--spacer));
  padding-bottom: var(--spacer);
}
